import React from 'react'
import { Form, Input } from 'antd'


function IdCardNumber() {

	return <div className='textarea-holder'><Form.Item
		name={['metadata', 'idCard', 'idCardNumber']}
		label={'Номер на лична карта'}
		className='input-box'
		rules={[
			{ required: true, message: 'Моля, въведи номер на лична карта' },
			{}
		]}
	>
		<Input
			className='input'
		/>
	</Form.Item>
	</div>
}

export default IdCardNumber
